export default {
  init: '发送验证码',
  end: '重新获取',
  toofast: '发送验证码过于频繁，请稍后再试'
}
